var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomFieldText = function SvgCustomFieldText(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.19 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#717171;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.02,
    y: 5.31,
    width: 12.15,
    height: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.02,
    y: 1.18,
    width: 12.15,
    height: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.02,
    y: 9.43,
    width: 6.13,
    height: 1.37
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomFieldText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "custom_field-text.57232d6e73da2e8f0a52a184291bbe46.svg";